import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/LandingPage.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/test',
    name: 'Test',
    component: () => import(/* webpackChunkName: "about" */ '../views/Test.vue')
  },
  {
    path: '/app/:eventId',
    name: 'App',
    component: () => import(/* webpackChunkName: "about" */ '../views/SelfieEvent.vue'),
    children: [
      {
        path: 'landing',
        name: 'LandingEvent',
        component: () => import(/* webpackChunkName: "about" */ '../views/App/LandingEvent')
      },
      {
        path: 'about-us',
        name: 'AboutUs',
        component: () => import(/* webpackChunkName: "about" */ '../views/App/AboutUs')
      },
      {
        path: 'contact',
        name: 'Contact',
        component: () => import(/* webpackChunkName: "about" */ '../views/App/Contact')
      },
      {
        path: 'selfie',
        name: 'TakeSelfie',
        component: () => import(/* webpackChunkName: "about" */ '../views/App/TakeSelfie')
      },
      {
        path: 'upload-photos',
        name: 'UploadPhotosToEvent.vue',
        component: () => import(/* webpackChunkName: "about" */ '../views/App/UploadPhotosToEvent.vue')
      },
      {
        path: 'my-photos',
        name: 'MyPhotos.vue',
        component: () => import(/* webpackChunkName: "about" */ '../views/App/MyPhotos.vue')
      }

    ]

  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue')
  },
  {
    path: '/auth',
    name: 'AuthCallback',
    component: () => import(/* webpackChunkName: "about" */ '../views/AuthCallback.vue')
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    children: [
      {
        path: 'event',
        name: 'Event',
        component: () => import(/* webpackChunkName: "about" */ '../views/Dashboard/Event')
      },
      {
        path: 'event/:id',
        name: 'EventDetail',
        component: () => import(/* webpackChunkName: "about" */ '../views/Dashboard/EventDetail')
      },
      {
        path: 'admin',
        name: 'Admin',
        component: () => import('../views/Dashboard/Admin')
      }

    ],
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "about" */ '../views/Dashboard.vue')
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    console.log('inside beforeEach - store.getters', store.getters, to, store.getters['login/GET_TOKEN'])
    if (!store.getters['login/GET_TOKEN']) {
      next({ name: 'Login' })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
